var path = '/var/www/mmscny-website/src/app/components/trip-planner/trip-planner-landing-page/trip-planner-landing-page.html';
var html = "<section> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 main-features\"> <div class=\"container no-padding\"> <div class=trip-planner-form-landing-page> <trip-planner-form type=tripPlannerLandingPage on-cancel=$ctrl.onChangeSearch() advance-options-details=$ctrl.advanceOptionsDetails direction-details=$ctrl.directionDetails> </trip-planner-form> </div> <feature-description-page-template details=$ctrl.details> </feature-description-page-template> </div> </div> </section> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trip-planner/trip-planner-landing-page/trip-planner-landing-page.html
// module id = 725
// module chunks = 0